document.addEventListener("DOMContentLoaded", function () {
  const contentAutoship = document.querySelectorAll(".js-content-autoship");
  const contentOtp = document.querySelectorAll(".js-content-otp");
  const labels = document.querySelectorAll("label[data-name-variant]");

  function updateDiscounts(type) {
    labels.forEach(function (label) {
      const letterValue = label.getAttribute("data-name-variant").toLowerCase();
      let contentSave = label.querySelector(".save");

      if (!contentSave) {
        contentSave = document.createElement("div");
        contentSave.classList.add("save");
        label.appendChild(contentSave);
      }

      if (type === "autoship") {
        if (letterValue === "1-pack"){
          contentSave.textContent = "SAVE 20%";
        } else if (letterValue === "2-pack") {
          contentSave.textContent = "SAVE 24%";
        } else if (letterValue.includes("3-pack")){
          contentSave.textContent = "SAVE 28%";
        } else if (letterValue.includes("4-pack bundle")) {
            contentSave.textContent = "SAVE 32%";
        } else if (letterValue.includes("powder-9-pack")) {
          contentSave.textContent = "SAVE 34%";
        } else if (letterValue.includes("12-pack-bundle")) {
            contentSave.textContent = "SAVE 36%";
        } else {
          contentSave.textContent = "";
          }
        }if (type === "onetime"){
          if (letterValue.includes("2-pack")){
            contentSave.textContent = "SAVE 5%";
          } else if (letterValue.includes("3-pack")){
            contentSave.textContent = "SAVE 10%";
          } else if (letterValue.includes("4-pack bundle")) {
              contentSave.textContent = "SAVE 15%";
          } else if (letterValue.includes("powder-9-pack")) {
            contentSave.textContent = "SAVE 18%";
          } else if (letterValue.includes("12-pack-bundle")) {
              contentSave.textContent = "SAVE 20%";
          } else {
            contentSave.textContent = "";
            }
      }
    });
  }

  contentAutoship.forEach(function (element) {
    element.addEventListener("click", function () {
      updateDiscounts("autoship");
    });
  });


  contentOtp.forEach(function (element) {
    element.addEventListener("click", function () {
      updateDiscounts("onetime");
    });
  });
});
